"use client"
import styled from "styled-components"

const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.border};
`

const TabsList = styled.div`
  display: flex;
  ${(props) =>
    props.fullWidth &&
    `
    width: 100%;
  `}
`

const TabButton = styled.button`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  background: none;
  border: none;
  border-bottom: 2px solid ${(props) => (props.active ? props.theme.primary : "transparent")};
  color: ${(props) => (props.active ? props.theme.primary : props.theme.text)};
  cursor: pointer;
  transition: all 0.2s;
  
  ${(props) =>
    props.fullWidth &&
    `
    flex: 1;
  `}
  
  &:hover {
    color: ${(props) => props.theme.primary};
  }
`

function Tabs({ tabs, activeTab, onChange, fullWidth = false }) {
  return (
    <TabsContainer>
      <TabsList fullWidth={fullWidth}>
        {tabs.map((tab) => (
          <TabButton key={tab.id} active={activeTab === tab.id} onClick={() => onChange(tab.id)} fullWidth={fullWidth}>
            {tab.label}
          </TabButton>
        ))}
      </TabsList>
    </TabsContainer>
  )
}

export default Tabs

